// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"c3b2eb4e","144":"995bb065"}[chunkId] + ".chunk.css";
};